import { defineRequest } from "@/lib/fetch-tools";
import { RequestResponse } from "./types";
import { getRequestDefinitionType } from "@/lib/fetch-utils";

export const apiCtmarketlist = defineRequest<RequestResponse<{
    records: Array<{
        id: number,
        coinname: string,
        name: string,
        symbol: string,
        title: string,
        status: number,
        state: number,
        sort: number,
        addtime: string,
        publishTime: string | null,
        publishNum: number,
        companyId: number,
        logo: string,
        infoZh: string | null,
        infoEn: string | null,
        infoEs: string | null,
        infoAr: string | null,
        infoVi: string | null,
        infoJa: string | null,
        infoDe: string | null,
        infoFr: string | null,
        infoPt: string | null,
        infoIt: string | null,
        whitePaper: string | null,
        website: string | null,
        blockQuery: string | null,
        type: number,
        issueName: string | null,
        price: number | null,
        coinType: number
    }>,
    total: number,
    size: number,
    current: number,
    orders: any[],
    optimizeCountSql: boolean,
    searchCount: boolean,
    countId: null,
    maxLimit: null,
    pages: number
}>, {
    pageNum: number,
    pageSize: number,
}>('/api/pc/index/ctmarketlist', {
  method: 'POST',
})
export type ApiCtmarketlistType = getRequestDefinitionType<typeof apiCtmarketlist>
